/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import * as D3 from 'd3';
import _ from 'lodash';

Vue.use(Vuex);

const URL_WORLD_MAP = 'data/custom.json';
const URL_COUNTRIES_STATS = 'data/countries_data.csv';

export default new Vuex.Store({

  state: {
    countries: false,
    selectedCountry: {},
    data: [],
    worldmap: false,
    rawdata: false,
    ready: false,
    years: [],
    filter: [
      {
        id: 'gesamtwertung', label: 'Gesamtwertung', unit: '€', value: 0, hide: true, tooltip: 'Der Index ist als Standortvergleich konzipiert, der speziell auf die Perspektive von großen Familienunternehmen ab einem Umsatzvolumen von mindestens 100 Millionen Euro eingeht. Die einbezogenen Standortkriterien sind die Bereiche „Steuern“, „Arbeitskosten, Produktivität,  Humankapital“, „Regulierung“, „Finanzierung“, „Infrastruktur und Institutionen“ und „Energie“.',
      },
      {
        id: 'steuern', label: 'Steuern', unit: '€', value: 0, rang: 0, tooltip: 'Der Subindex „Steuern“ ordnet die steuerliche Belastung großer Familienunternehmen bei nationaler Geschäftstätigkeit, im Erbfall, bei grenzüberschreitender Geschäftstätigkeit und die Komplexität des Steuersystems ein.',
      },
      {
        id: 'finanzierung', label: 'Finanzierung', icon: 'icon-bip', unit: '€', value: 0, rang: 0, tooltip: 'Das Themengebiet „Finanzierung“ beschäftigt sich mit den Voraussetzungen für Familienunternehmen, die für ihre tägliche Geschäftstätigkeit und für Investitionen erforderlichen Finanzmittel zu beschaffen, sowie mit den Rahmenbedingungen einer gesicherten Finanzierung durch das Finanz- und Währungssystem.',
      },
      {
        id: 'arbeitskosten', label: 'Arbeitskosten, Produktivität, Humankapital', icon: 'icon-bip', unit: '€', value: 0, rang: 0, tooltip: 'Mit der Einbeziehung von Arbeitskosten, Arbeitsproduktivität und Verfügbarkeit qualifizierter Arbeitskräfte eines Landes werden sowohl die Kosten- und Ertragsseite als auch die Qualitätsdimension des Faktors Arbeit erfasst. Dazu zählt auch der Blick auf die Bildungsausgaben, die PISA-Ergebnisse sowie das Bildungsniveau der Bevölkerung.',
      },
      {
        id: 'infrastruktur', label: 'Infrastruktur und Institutionen', icon: 'icon-bip', unit: '€', value: 0, rang: 0, tooltip: 'Im Themengebiet „Infrastruktur und Institutionen“ werden zum einen Leistungen der unternehmensnahen Infrastruktur, zum anderen Aspekte des rechtlich-institutionellen Umfelds untersucht. Zur unternehmensnahen Infrastruktur zählen die Transportinfrastruktur und die Informations- und Kommunikationsinfrastruktur. Im Bereich des rechtlich-institutionellen Umfelds werden Fragen der Rechtssicherheit, Korruptionskontrolle und Kriminalität und politischen Stabilität näher beleuchtet.',
      },
      {
        id: 'regulierung', label: 'Regulierung', icon: 'icon-bip', unit: '€', value: 0, rang: 0, tooltip: 'Das Themengebiet „Regulierung“ befasst sich mit Barrieren, mit denen Familienunternehmen bei der Einstellung, bei der Kündigung und in Lohnverhandlungen mit Arbeitnehmern, im Außenhandel, bei der Gründung eines neuen Unternehmensstandorts und in anderen Bereichen ihrer Geschäftstätigkeit konfrontiert sind.',
      },
      {
        id: 'energie', label: 'Energie', icon: 'icon-bip', unit: '€', value: 0, rang: 0, tooltip: 'In die Berechnung des Subindex sind die Teilindikatoren „Strompreise“ und „Gas und Kraftstoffpreise“, „Stromversorgungssicherheit“, „Energieimportrisiko“ sowie die Erreichung der „Klimaziele“ einbezogen worden.',
      },
    ],
    mapLabels: {
      portrait: {
        label: 'Wählen Sie auf der Karte ein Land aus.',
        show: 1,
      },
      comparison: {
        label: 'Vergleichen Sie bis zu vier Länder und wählen Sie unten einen Themenbereich aus.',
        show: 1,
      },
      ranking: {
        label: 'Wählen Sie unten einen Themenbereich aus.',
        show: 1,
      },
    },
  },

  mutations: {

    SET_WORLD_DATA: (state, payload) => {
      state.worldmap = payload;
    },

    SET_RAW_DATA: (state, payload) => {
      state.rawdata = payload;
    },

    SET_READY: (state, payload) => {
      state.ready = payload;
    },

    SET_COUNTRY: (state, payload) => {
      state.selectedCountry = payload;
    },

    SET_RANKINGS: (state, payload) => {
      const data = [];
      const dataProYear = [];
      let allData = [];

      // add stats array with filter information
      for (let i = 0; i < payload.length; i += 1) {
        const row = payload[i];
        // ignore empty rows / countries

        if (row.Steuern !== '') {
          const stats = state.filter.slice(0);

          for (let j = 0; j < stats.length; j += 1) {
            // stats[j].value = Math.round(row[stats[j].label].replace(',', '.'));
            if (row[stats[j].label] !== undefined) stats[j].value = parseFloat(row[stats[j].label].replace(',', '.'));
          }
          row.stats = stats;
          data.push(JSON.parse(JSON.stringify(row)));
        }
      }

      // add ranking for each stat
      for (let i = 0; i < state.years.length; i += 1) {
        const year = state.years[i];
        let tmp = [];

        for (let j = 0; j < data.length; j += 1) {
          if (data[j].Jahr === year) tmp.push(JSON.parse(JSON.stringify(data[j])));
        }

        for (let f = 0; f < state.filter.length; f += 1) {
          const filter = state.filter[f].label;
          // sort by filter
          tmp = tmp.slice().sort(
            (a, b) => {
              const x = (parseFloat(a[filter])) ? parseFloat(a[filter]) : 0;
              const y = (parseFloat(b[filter])) ? parseFloat(b[filter]) : 0;
              return y - x;
            },
          );
          // set ranking
          for (let l = 0; l < tmp.length; l += 1) {
            tmp[l].stats[f].rang = l + 1;
          }
        }
        allData = allData.concat(JSON.parse(JSON.stringify(tmp)));
      }
      state.data = allData;
    },

    SET_YEARS: (state, payload) => {
      const years = [];
      for (let i = 0; i < payload.length; i += 1) {
        const year = payload[i].Jahr;
        if (years.indexOf(year) < 0) years.push(year);
      }
      state.years = years;
    },

  },

  actions: {

    SET_COUNTRY: async (context, country) => {
      context.commit('SET_COUNTRY', country);
    },

    LOAD_APP_DATA: async (context) => {
      const response = await Axios.get(URL_COUNTRIES_STATS);
      const dsv = D3.dsvFormat(';');
      const data = dsv.parse(response.data);

      context.commit('SET_RAW_DATA', data);
      context.commit('SET_YEARS', data);
      context.commit('SET_RANKINGS', data);
      context.commit('SET_READY', true);
    },
    LOAD_WORLD_DATA: async (context) => {
      if (!context.state.worldmap) {
        const response = await Axios.get(URL_WORLD_MAP);
        // let sss = JSON.parse(JSON.stringify(response.data))
        context.commit('SET_WORLD_DATA', response.data);
      } else {
        context.commit('SET_WORLD_DATA', context.state.worldmap);
      }
    },
  },

  getters: {

    getSettings: () => {
      const w = window;
      const d = document;
      const e = d.documentElement;
      const g = d.getElementsByTagName('body')[0];
      const x = w.innerWidth || e.clientWidth || g.clientWidth;
      const y = w.innerHeight || e.clientHeight || g.clientHeight;
    },

    getCountryStats: (state, getters) => (countryCode, year) => state.data.find((country) => {
      if (country.Id === countryCode && country.Jahr === year) {
        return country;
      }
    }),

    hasCountryDataForYear: state => year => {
      if (!state.selectedCountry) return;
      const stats = _.filter(state.data, d => (d.Jahr === year) && (d.Id === state.selectedCountry.Id) );
      return (stats.length > 0) ? true : false;
    },

    getCountriesStats: state => (filter, year) => {
      if (!filter.label) return false;

      const rankings = [];
      const stats = _.filter(state.data, d => d.Jahr === year);

      _.forEach(stats, (stat) => {
        const curFilter = _.find(stat.stats, o => o.label === filter.label);
        const totalFilter = _.find(stat.stats, o => o.label === 'Gesamtwertung');
        rankings.push({
          id: stat.Id,
          land: stat.Land,
          // value: parseFloat(curFilter.value),
          value: curFilter.value,
          rang: totalFilter.rang,
        });
      });

      return _.orderBy(rankings, [
        function (item) { return item.value; },
        function (item) { return item.rang; }
      ], ['desc', 'asc']);
    },

    getCountries: state => (year) => {
      const countries = [];
      for (let i = 0; i < state.data.length; i += 1) {
        countries.selected = false;
        if (state.data[i].Jahr === year) countries.push(state.data[i]);
      }
      return _.orderBy(countries, 'Land', 'asc');
    },

    getFilter: state => state.filter,

    getMapLabels: state => () => {
      state.mapLabels;
    },
    getRankings: state => (filter) => {
      const allRankings = [];
      let maxRankings = 0;

      _.forEach(state.years, (year, key) => {
        const statsYear = _.filter(state.data, d => d.Jahr === year);
        let rankings = [];

        _.forEach(statsYear, (stat, sKey) => {
          const curStat = _.find(stat.stats, d => d.id === filter.id);
          // todo
          if (!curStat) return '';

          const ranking = {
            id: `${year}_${sKey}`,
            year: `${year}`,
            value: parseFloat(curStat.value),
            rang: curStat.rang,
            countryId: stat.Id,
            active: false,
          };
          rankings.push(ranking);
        });

        // todo
        if (key === 0) maxRankings = rankings.length;
        const max = maxRankings - rankings.length;
        for (let k = 0; k < max; k += 1) {
          rankings.push({
            year,
          });
        }
        rankings = _.orderBy(rankings, ['rang', 'year'], ['asc', 'desc']);
        allRankings.push(rankings);
      });
      return _.orderBy(allRankings);
    },
  },
});
